const FONTS = {
  FONTS: '/fonts',
  FONT_DELETE: '/font/delete/:identifier',
  FONT_UPLOAD_CUSTOM: '/font/upload/custom',
  FONT_UPLOAD_GOOGLE_FONTS: '/font/upload/google-fonts'
}

export default FONTS
